import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/context/LangContext";
import { MultiLangField, MediaField } from "@/components/admin/Fields";

export const ContentSettings = ({ draft, set }) => {
  const { t } = useLang();
  return (
    <div className="space-y-8">
      <div className="max-w-md space-y-2">
        <Label className="text-sm font-bold">{t("org_name")}</Label>
        <Input value={draft.org_name} onChange={(e) => set("org_name", e.target.value)} data-testid="admin-settings-org-name-input" />
      </div>
      <MultiLangField label={t("hero_title")} value={draft.hero_title} onChange={(v) => set("hero_title", v)} testPrefix="admin-settings-hero-title" />
      <MultiLangField label={t("hero_subtitle")} value={draft.hero_subtitle} onChange={(v) => set("hero_subtitle", v)} multiline testPrefix="admin-settings-hero-subtitle" />
      <MultiLangField label={t("about_text")} value={draft.about_text} onChange={(v) => set("about_text", v)} multiline testPrefix="admin-settings-about" />
    </div>
  );
};

export const MediaSettings = ({ draft, set }) => {
  const { t } = useLang();
  return (
    <div className="space-y-5">
      <MediaField label={t("logo")} value={draft.logo_url} onChange={(v) => set("logo_url", v)} testPrefix="admin-settings-logo" />
      <MediaField label={t("hero_image")} value={draft.hero_image_url} onChange={(v) => set("hero_image_url", v)} testPrefix="admin-settings-hero-image" />
      <MediaField label={t("hero_image_2")} value={draft.hero_image_2_url} onChange={(v) => set("hero_image_2_url", v)} testPrefix="admin-settings-hero-image-2" />
      <MediaField label={t("hero_image_3")} value={draft.hero_image_3_url} onChange={(v) => set("hero_image_3_url", v)} testPrefix="admin-settings-hero-image-3" />
    </div>
  );
};
